import { DocumentParser, ParsedDocument, ScanContext } from '../core/types';
import { mrzToFields, parseTd1 } from './mrz/td1';

/**
 * ICAO 9303 TD1 machine-readable zone (the lines printed on a CIN/RG card).
 * Fed via `ctx.mrzText` (manual paste today; OCR later). Validates check digits.
 */
export class MrzParser implements DocumentParser {
  readonly id = 'mrz-td1';
  readonly label = 'MRZ (TD1)';

  detect(ctx: ScanContext): boolean {
    return !!ctx.mrzText && parseTd1(ctx.mrzText) !== null;
  }

  parse(ctx: ScanContext): ParsedDocument {
    const mrz = parseTd1(ctx.mrzText!)!;
    return {
      kind: 'mrz-td1',
      title: 'MRZ (TD1)',
      country: mrz.issuingCountry || 'BR',
      parser: this.id,
      fields: mrzToFields(mrz),
      raw: mrz,
    };
  }
}
